import firstSlide from './1.md'
import secondSlide from './2.md'
import thirdSlide from './3.md'
import fourthSlide from './4.md'
import fifthSlide from './5.md'

const slides = [firstSlide, secondSlide, thirdSlide, fourthSlide, fifthSlide]

export default slides
